import { Fragment, useEffect } from "react";


const PinInput = ({fields = 6, checking = false, className}) => {

    const handleChange = e => {
        const input = e.currentTarget;
        // Allow support for pasting Pin from clipboard
        if (input.value.length === fields){
            const val = input.value;
            for (let i = 0; i < fields; i++){
                document.querySelector(`input[name="input${i}"]`).value = val[i];
            }
            return;
        }

        input.value = input.value?.substr(-1);
        if (input.checkValidity()){
            let nextIndex = Number(input.name?.substr(-1)) + 1;
            nextIndex = nextIndex >= fields ? 0 : nextIndex;
            // Focus on next input field
            document.querySelector(`input[name="input${nextIndex}"]`).focus();
        }
    }

    useEffect(_ => {
        document.querySelector(`input[name="input0"]`)?.focus();
    }, [])

    return  <div className={`flex space-x-0.5 ${className}`}>
                {
                    [...Array(fields)].map((_, i) => <Fragment key={i}>
                                                        {i === 3 && <span className="inline-block px-1 sm:px-3 text-grey-3 my-auto"> - </span>}
                                                        <input 
                                                            name={`input${i}`}
                                                            required
                                                            minLength="1"
                                                            pattern="[\d]{1,}"
                                                            className={`form-input w-12 h-14 sm:w-16 sm:h-20 pl-5 text-lg sm:text-2xl rounded ${ checking && "border-primary"}`}
                                                            placeholder=""
                                                            readOnly={checking}
                                                            onChange={handleChange}
                                                        />
                                                    </Fragment>
                                            )     
                }  
            </div>
}

export default PinInput;